<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Delete {{messages.ids.length}} items
        </cll-dialog-title>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">

                <cll-panel-tonal colour="info">
                    <cll-icon cllPanelIcon>info</cll-icon>
                    <div class="panel-text-group">
                        <span class="panel-text-header">Warning</span>
                        <p>This will permanently delete the message from your inbox. This action cannot be undone</p>
                    </div>
                </cll-panel-tonal>
             

            <span>Are you sure you want to proceed.</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (deleteMessagesRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"

                (click)="delete()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
